import React, { useState } from 'react';
import { Form, Modal } from 'reactstrap';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { ReactComponent as Icon } from 'assets/icons/Profile/UserIcon.svg';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

import ButtonBlue from 'components/button/buttonBlue';
import { handleForgotPassword } from 'api-services/auth';
import CommonInput from 'components/input/CommonInput';
import { createNotification } from 'common/create-notification';
import SmallLoader from 'common/smallLoader';
// import { createNotification } from 'common/create-notification';

const ForgotPasswordModal = ({ modalOpen, toggle }) => {
  const { control, handleSubmit, formState } = useForm({
    resolver: yupResolver(passwordSchema)
  });
  const { errors } = formState;

  const [loading, setLoading] = useState(false);

  const onSubmit = async (formData) => {
    const newFormData = new FormData();
    for (const key in formData) {
      newFormData.append(key, formData[key]);
    }
    setLoading(true);
    const res = await handleForgotPassword({
      email: newFormData
    });
    if (!res) {
      toggle();
    }
    if (res.status === false) {
      createNotification('error', res.message);
      toggle();
    }
    if (res.status === true) {
      createNotification('success', res.message);
      setLoading(false);
      toggle();
    }
  };

  return (
    <>
      <Modal
        zIndex={2000}
        centered
        size="lg"
        isOpen={modalOpen}
        toggle={toggle}>
        <div className=" col-12">
          <Card className="card-radius card-bg">
            <div className="text-center card-main-heading pt-4 pr-4">
              {<Icon className="pr-1 pb-1" />} Forgot Password
            </div>
            {loading ? (
              <>
                <SmallLoader />
              </>
            ) : (
              <CardBody className="">
                <Form onSubmit={handleSubmit(onSubmit)}>
                  <Row className="pt-3">
                    <Col>
                      <div className="">
                        <div className="pt-1">
                          <Controller
                            control={control}
                            name="email"
                            defaultValue={''}
                            render={({ field }) => (
                              <CommonInput
                                type="email"
                                labelValue={'Email Address'}
                                invalid={errors?.email && true}
                                {...field}
                              />
                            )}
                          />
                          {errors?.email?.message !== undefined && (
                            <div className="text-danger mt-1 text-12">
                              {`*${errors?.email?.message}`}
                            </div>
                          )}
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col>
                      <div className="pt-4 text-center">
                        <ButtonBlue classes={'px-5'} type="submit">
                          Submit
                        </ButtonBlue>
                      </div>
                    </Col>
                  </Row>
                </Form>
              </CardBody>
            )}
          </Card>
        </div>
      </Modal>
    </>
  );
};

export default ForgotPasswordModal;

const passwordSchema = yup.object().shape({
  email: yup
    .string()
    .required('Email is Required')
    .email('Please enter valid email address')
});
